module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_03_6DB79_1SB_GLR.5906ab54.png";